import React, {useCallback, useMemo, useRef, useState} from 'react';
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";
import laneAliasService from "../../../../services/web/lane-alias-service.js";
import AgGridUtils from "../../../../utils/aggrid-utils.js";

const LaneAliasList = () => {
    const navigate = navigateHook();

    const [filter, setFilter] = useState("");

    const {data} = useQuery({
        queryFn: () => laneAliasService.list(),
        queryKey: ["sessions"]
    });

    const [columnDefs,] = useState([
        { field: "name", headerName: "Nome", sort: "asc", flex: 1, comparator: AgGridUtils.nullLastComparator},
    ]);

    const gridRef = useRef(undefined);

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const apply = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            filter,
        )
    }, [filter])

    const clear = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            "",
        );

        setFilter("")
    }, [])

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clear);


    const onCellClicked = ({data}) => {
        navigate(`/lane-alias/form/${data.id}`)
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>Grupos de seleção de câmeras (SentryView)</Template.Title>

                <Button target={"primary"} onClick={() => navigate("/lane-alias/form")}>
                    <FaPlus/> Adicionar grupo
                </Button>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <div className="flex justify-between gap-4">
                            <InputForm
                                classNameWrapper={"w-full"}
                                id={"name"}
                                label={"Nome"}
                                name={"name"}
                                value={filter}
                                onChange={({target: {value}}) => setFilter(value)}
                            />

                            <div className={"flex gap-2"}>
                                <Button target={"default"} onClick={clear} title={"Limpar"}>
                                    <FaEraser />
                                </Button>
                                <Button onClick={apply} title={"Buscar"}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className={"aggrid-row-pointer h-[calc(100vh-153px)]"}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                                onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default LaneAliasList;